import styled from "styled-components";

export const RelatedLayerDescription = styled.div`
  margin: 1rem 0;
`;
